export default __webpack_public_path__ + "static/media/screen11.eebd95df.svg";